import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { sortByColumn } from './utils/sorters';
import { ContentControlWebAccessRule } from '@nirvana/shared/dtos/types/policies/common';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';

export class GzContentControlWebAccessExceptionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ContentControlWebAccessRule
> {
  sortByColumnMethod(
    a: ContentControlWebAccessRule,
    b: ContentControlWebAccessRule,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.WEB_ADDRESS);
    return;
  }
}
